import { useQuery } from 'apollo-3';

import { useClassroomContext } from 'Context/ClassroomContext';
import { classroomDownloadableCourseAssets } from 'GraphQL/query/Classroom.query';

const useClassroomDownloadableCourseAssets = ({ ...props }) => {
  const { classroomCourseId } = useClassroomContext();

  const { data, loading, error } = useQuery(classroomDownloadableCourseAssets, {
    variables: {
      classroomCourseId,
    },
    ...props,
  });

  return {
    data,
    loading,
    error,
  };
};

export default useClassroomDownloadableCourseAssets;
